import APIUtils from '@spothero/utils/api';
import UserUtils from 'utils/user-utils';

const UserAPI = {
    lookup(email) {
        return APIUtils.get('users/', {
            email,
            include: UserUtils.INCLUDES,
        })
            .then(payload => payload.data.data)
            .then(UserUtils.formatPayload);
    },

    lookupByReservation(reservationId) {
        return APIUtils.get('users/', {
            reservation_id: reservationId, // eslint-disable-line camelcase
        })
            .then(payload => payload.data.data)
            .then(UserUtils.formatPayload);
    },

    getUser(config = {}) {
        return APIUtils.get(
            'users/me/',
            {
                include: UserUtils.INCLUDES,
            },
            config
        )
            .then(payload => payload.data.data)
            .then(UserUtils.formatPayload);
    },

    getUserReservations(userId, count) {
        return APIUtils.get(`users/${userId}/reservations/`, {
            page_size: count, // eslint-disable-line camelcase
        }).then(({data}) => data?.data);
    },

    isAuthenticated(config = {}) {
        return APIUtils.get('users/logged-in/', null, config).then(
            ({
                data: {
                    data: {logged_in: loggedIn},
                },
            }) => loggedIn
        );
    },
};

export default UserAPI;
